function scopePath(scope) {
  if (scope.type === 'group') return `ticket-group/${scope.groupId}`
  return 'ticket-account'
}

class PathUtility {
  /**
   * URL path prefix for ticket-settings API calls. Account scope returns
   * `ticket-account`; group scope returns `ticket-group/:groupId`.
   *
   * @param {{ type: 'account' | 'group', groupId?: string|null }} scope
   * @returns {string}
   */
  scope(scope) {
    return scopePath(scope)
  }
}

export default new PathUtility()
